import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { handleOutsideClick } from "../../../Helpers/HandleOutsideClick";

const InterviewDecisionModal = ({
	show,
	onClose,
	onFinish,
	statusList,
	selectedStatus,
	setSelectedStatus,
	remarks,
	setRemarks,
}) => {
	const [isVisible, setIsVisible] = useState(false);
	const [shouldRender, setShouldRender] = useState(show);

	useEffect(() => {
		document.body.style.overflow = show ? "hidden" : "auto";

		if (show) {
			setShouldRender(true);
			setTimeout(() => setIsVisible(true), 10);
		} else {
			setIsVisible(false);
			setTimeout(() => setShouldRender(false), 500);
		}

		return () => (document.body.style.overflow = "auto");
	}, [show]);

	if (!shouldRender) return null;

	return (
		<div
			className={`fixed inset-0 z-[80] flex justify-end transition-opacity duration-500
      ${isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"}`}
			onClick={(e) => handleOutsideClick(e, onClose)}
		>
			{/* Drawer */}
			<div
				onClick={(e) => e.stopPropagation()}
				className={`
          bg-white h-full w-[40%] min-w-[420px]
          shadow-[ -10px_0px_30px_rgba(0,0,0,0.15) ]
          flex flex-col
          transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]
          ${isVisible ? "translate-x-0" : "translate-x-full"}
        `}
			>
				{/* Header */}
				<div className="bg-blue-600 text-white px-6 py-4 flex justify-between items-center">
					<h2 className="text-lg font-semibold">Interview Decision</h2>

					<button onClick={onClose} className="hover:text-gray-200">
						<X size={20} />
					</button>
				</div>

				{/* Body */}
				<div className="flex-1 overflow-y-auto p-6 space-y-6">
					{/* Status */}
					<div>
						<label className="font-semibold text-blue-600 flex">
							Interview Conclusion
							<span className="text-red-500 ml-1">*</span>
						</label>

						<select
							className="mt-2 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
							value={selectedStatus}
							onChange={(e) => setSelectedStatus(e.target.value)}
						>
							<option value="">-- Select Status --</option>

							{statusList.map((item) => (
								<option key={item.statusID} value={item.statusID}>
									{item.status}
								</option>
							))}
						</select>
					</div>

					{/* Remarks */}
					<div>
						<label className="font-semibold text-blue-600 flex">
							Interview Remarks
							<span className="text-red-500 ml-1">*</span>
						</label>

						<textarea
							rows={4}
							placeholder="Enter your remarks about the candidate"
							value={remarks}
							onChange={(e) => setRemarks(e.target.value)}
							className="mt-2 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
						/>
					</div>
				</div>

				{/* Footer */}
				<div className="flex justify-end gap-3 px-6 py-4 border-t">
					<button
						onClick={onClose}
						className="px-4 py-2 rounded-lg border hover:bg-gray-100"
					>
						Cancel
					</button>

					<button
						onClick={onFinish}
						className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
					>
						Finish
					</button>
				</div>
			</div>
		</div>
	);
};

export default InterviewDecisionModal;
